import {
  AccessDenied,
  FeatureToggleList as FeatureToggleListComponent,
} from '@verifime/components';

import { getFeatureToggleConfigWithResolvedValue, TApp } from '@verifime/utils';
import { useUser } from './UserContext';

export const FrontendFeatureToggleList = ({ app }: Readonly<{ app: TApp }>) => {
  const { state: userState } = useUser();

  const toggles = getFeatureToggleConfigWithResolvedValue(app);

  if (userState.status !== 'authenticated' || !userState.isAdmin) {
    return <AccessDenied />;
  }

  return (
    <FeatureToggleListComponent title="Frontend Feature Toggles" togglesWithConfig={toggles} />
  );
};
